import { render, staticRenderFns } from "./VircosMaterials.vue?vue&type=template&id=798d6a08&scoped=true&"
import script from "./VircosMaterials.vue?vue&type=script&lang=js&"
export * from "./VircosMaterials.vue?vue&type=script&lang=js&"
import style0 from "./VircosMaterials.vue?vue&type=style&index=0&id=798d6a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798d6a08",
  null
  
)

export default component.exports